export default "__VITE_ASSET__AkWEn92Z__"